import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import singleSpaReact from 'single-spa-react'
import './i18n.main'
import Root from './root.component'
import './index.scss'

const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: (props) => <Root {...(props as any)} />,
  errorBoundary(err, info, props) {
    if (err?.stack?.includes('systemjs')) {
      history.pushState({}, '', '/error/general-error')
    }
    return <div></div>
  },
})

export const { bootstrap, mount, unmount } = lifecycles
